// Rutas imagenes
export const imgSrcLogoITI = `${
	import.meta.env.VITE_PUBLIC_PATH
}assets/ITI-logo-compressed.svg`;

export const imgSrcLogoWhisephere = `${
	import.meta.env.VITE_PUBLIC_PATH
}assets/logo-wisephere-black.svg`;

export const imgSrcLogoFinanciaciones = `${
	import.meta.env.VITE_PUBLIC_PATH
}assets/Footer-logos.svg`;

// Validaciones
export function getRequiredUsername(t: (key: string) => string) {
	return [
		{
			type: "required",
			message: t("login.required-user"),
		},
	];
}

export function getRequiredPassword(t: (key: string) => string) {
	return [
		{
			type: "required",
			message: t("login.required-password"),
		},
	];
}

export function getRequiredEmail(t: (key: string) => string) {
	return [
		{
			type: "required",
			message: t("login.required-email"),
		},
		{
			type: "email",
			message: t("login.invalid-email"),
		},
	];
}
